import React from 'react';
import PropTypes from 'prop-types';
import RelationImportModelDetail from '@/modules/documents/details/RelationImportModelDetail';
import EidDetail from './EidDetail';
import RelationDocumentDetail from './RelationDocumentDetail';
import AuthorizationListDetail from './details/AuthorizationListDetail';
import RegistrationListDetail from './details/RegistrationListDetail';

export const documentTypesWithDetails = [
  10, // Eid
  19, // AuthorizationList
  1000, // RegistrationList
];

const DocumentDetailRow = ({ document }) => {
  switch (document.documentType) {
    case 10:
      return <EidDetail document={document} />;
    case 11: // Assignment letter
    case 29: // Generated document
      return <RelationDocumentDetail document={document} />;
    case 19:
      return <AuthorizationListDetail document={document} />;
    case 1000:
      return <RegistrationListDetail document={document} />;
    default:
      if (document.hasRelationImportModel) {
        return <RelationImportModelDetail document={document} />;
      }
      return <span />;
  }
};

DocumentDetailRow.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default DocumentDetailRow;
